import { useAuth } from "links/lib/features/auth";
import { useStartUserSession } from "links/lib/features/users";
import { AnalyticsEvent } from "links/lib/types";

import { useHubSpot } from "./useHubSpot";

export const useUserSession = (): void => {
  const { authUser } = useAuth();
  const { trackHubSpotEvent } = useHubSpot();

  const enableStartUserSession = !!authUser && !authUser.is_ephemeral;

  useStartUserSession({
    onSuccess: ({ is_first_user_session }) => {
      if (is_first_user_session) {
        trackHubSpotEvent(AnalyticsEvent.HubSpot_FirstLogin);
      }
    },
    enabled: enableStartUserSession,
  });
};
